import { useEffect, useRef } from 'react';

export function useScheduleOpen({ openDelayMs, setOpen }) {
  const openTimerRef = useRef(null);

  const clear = () => {
    if (openTimerRef.current != null) {
      window.clearTimeout(openTimerRef.current);
      openTimerRef.current = null;
    }
  };

  useEffect(() => () => clear(), []);

  const schedule = (e) => {
    clear();
    if (openDelayMs > 0 && e.pointerType === 'mouse') {
      openTimerRef.current = window.setTimeout(() => {
        openTimerRef.current = null;
        setOpen(true);
      }, openDelayMs);
      return;
    }
    setOpen(true);
  };

  return { schedule, clear, openTimerRef };
}
